<script lang="ts">
    import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
    import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
    import { lastValueFrom } from "rxjs";

    import WishlistButton from "./WishlistButton.svelte";

    export let productId: number;
    export let variantId: number;
    export let wishlistsService: WishlistsService;

    export let wishlistProductStatusesQuery: WishlistProductStatusesQuery;

    $: inWishlist$ =
        wishlistProductStatusesQuery.selectProductInWishlistStatus(productId);

    const handleAdd = () => {
        lastValueFrom(wishlistsService.addItem({ productId, variantId, wishlistId: null }));
    };
    const handleDelete = () => {
        lastValueFrom(
            wishlistsService.deleteItem({
                productId,
                variantId,
                wishlistId: null
            })
        );
    };
</script>

<WishlistButton {handleAdd} {handleDelete} inWishlist={$inWishlist$} />
